export default function GameStudio ({country}: { country: 'south-africa' | 'nigeria' }) {
  return (
    <div className="App game-studio">
        <a href={`/${country}`} className="game-back-link">&larr; Back to TV Guide</a>
        <p>Pick a game and jump in. These are experimental — best experienced on mobile.</p>
        <h1>Game Studio</h1>
        <div className="game-cards">
            <a className="game-card" href={`/sky-hopper/${country}`}>
                <div className="game-card-icon">🐦</div>
                <h2 className="game-card-title">Sky Hopper</h2>
                <div className="game-card-version">v1.0 &middot; Arcade</div>
            </a>
            <a className="game-card" href={`/neon-snake/${country}`}>
                <div className="game-card-icon">🐍</div>
                <h2 className="game-card-title">Neon Snake</h2>
                <div className="game-card-version">v1.0 &middot; Classic</div>
            </a>
            <a className="game-card" href={`/dot-eater/${country}`}>
                <div className="game-card-icon">🟡</div>
                <h2 className="game-card-title">Dot Eater</h2>
                <div className="game-card-version">v1.0 &middot; Arcade</div>
            </a>
            <a className="game-card" href={`/hangman/${country}`}>
                <div className="game-card-icon">🎮</div>
                <h2 className="game-card-title">Hangman</h2>
                <div className="game-card-version">v1.0 &middot; Word</div>
            </a>
            <a className="game-card" href={`/word-ladders/${country}`}>
                <div className="game-card-icon">🪜</div>
                <h2 className="game-card-title">Word Ladders</h2>
                <div className="game-card-version">v1.0 &middot; Word</div>
            </a>
            <a className="game-card" href={`/jigsaw/${country}`}>
                <div className="game-card-icon">🧩</div>
                <h2 className="game-card-title">Jigsaw Puzzle</h2>
                <div className="game-card-version">v1.0 &middot; Puzzle</div>
            </a>
            <a className="game-card game-card-crossword" href={`/crossword/${country}`}>
                <div className="game-card-icon">📰</div>
                <h2 className="game-card-title">Movie Crossword</h2>
                <div className="game-card-version">Daily &middot; Movie trivia</div>
            </a>
        </div>
    </div>
  );
}
